import { extendTheme } from "@chakra-ui/react";

import styles from "./styles";
const breakpoints = {
  sm: "40em",
  md: "52em",
  lg: "64em",
  xl: "80em",
};

const components = {
  Button: {
    variants: {
      pri_btn: {
        // Your custom variant styles here
        // For example:
        backgroundColor: "red",
        color: "white",
        borderRadius: "8px",
        minWidth: "6rem",
        width: "auto",
        padding: "5px 8px",
        _hover: {
          opacity: "95%"
        },
      },
    },
  },
} 
export default extendTheme(styles, breakpoints, components);
